import PodcastSeriesPage from './PodcastSeriesPage';


export {
    PodcastSeriesPage,
}


// WEBPACK FOOTER //
// src/client/components/site/features/training/podcasts/series/index.js